<hlm-dialog [state]="client() ? 'open' : 'closed'" (stateChanged)="onDialogState($event)">
  <hlm-dialog-content *hlmDialogPortal class="sm:max-w-md">
    <div hlmDialogHeader>
      <h3 hlmDialogTitle>Anmelde-Link erneut schicken</h3>
      <p hlmDialogDescription>
        {{ client()?.name || 'Dein Kunde' }} bekommt noch einmal die E-Mail, mit der er ein eigenes
        Passwort festlegt. Kam sie nicht an? Prüfe die Adresse und korrigiere sie hier.
      </p>
    </div>

    <form
      [formGroup]="form"
      (ngSubmit)="submit()"
      class="flex flex-col gap-5"
      novalidate
      id="claim-mail-form">
      <div hlmField>
        <label hlmFieldLabel for="claim-mail-email">E-Mail-Adresse deines Kunden</label>
        <input
          hlmInput
          id="claim-mail-email"
          type="email"
          inputmode="email"
          formControlName="email"
          autocomplete="off"
          class="w-full"
          [attr.aria-invalid]="emailInvalid ? 'true' : null" />
        @if (emailInvalid) {
          <p hlmFieldDescription class="text-destructive">
            Bitte gib eine gültige E-Mail-Adresse ein
          </p>
        }
      </div>

      @if (error()) {
        <div hlmAlert variant="destructive" role="alert">
          <ng-icon name="lucideTriangleAlert" />
          <p hlmAlertTitle>{{ error() }}</p>
        </div>
      }
    </form>

    <div hlmDialogFooter>
      <button hlmBtn variant="outline" type="button" [disabled]="loading()" (click)="dismiss()">
        Abbrechen
      </button>
      <button
        hlmBtn
        type="submit"
        form="claim-mail-form"
        [disabled]="loading()"
        [attr.aria-busy]="loading()">
        @if (loading()) {
          <hlm-spinner />
        }
        Senden
      </button>
    </div>
  </hlm-dialog-content>
</hlm-dialog>
